import { render, staticRenderFns } from "./ReservaListExpress.vue?vue&type=template&id=1252696e&"
import script from "./ReservaListExpress.vue?vue&type=script&lang=js&"
export * from "./ReservaListExpress.vue?vue&type=script&lang=js&"
import style0 from "./ReservaListExpress.vue?vue&type=style&index=0&id=1252696e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports